import { Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useLoadMore from "hooks/useLoadMore";
import TireListSearch from "../components/TireListSearch";
import TableTireList from "../components/TableTireList";
import { Tire } from "../types/tire";
import useTireList from "../hooks/useTireList";
import TireFormModal from "../components/TireFormModal";

/**
 * The TireList Page.
 */
function TireList() {
  const navigate = useNavigate();
  const { total, tires, params, setParams, handleSearch, onLoadMore, loading, handleUpdate } =
    useTireList();
  const [selectedTire, setSelectedTire] = useState<Tire | null>(null);
  const [isShowModal, setIsShowModal] = useState(false);
  const { renderNodeLoader } = useLoadMore(onLoadMore, loading);

  const onHandleCloseModal = () => {
    setIsShowModal(false);
    setSelectedTire(null);
  };

  const onHandleUpdate = async (tire?: Tire) => {
    await handleUpdate(tire);
    setIsShowModal(false);
  };

  return (
    <>
      <Box sx={{ px: { xs: 2, md: 2.5, lg: 5 }, pt: { xs: 2, md: 2.5, lg: 3 } }}>
        <Button onClick={() => navigate(-1)} variant="custom-outlined">
          <Box>＜ 戻る</Box>
        </Button>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          p: { xs: 2, md: 2.5, lg: 5 },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: { xs: "column", lg: "row" }, mb: 5 }}>
        <Box
          sx={{
            maxWidth: "fit-content",
            paddingInline: { xs: "22px", lg: "46px" },
          }}
        >
          <Typography
            margin={0}
            sx={{
              fontSize: { xs: 16, md: 28, lg: 33 },
              textAlign: "right",
              color: "var(--gray-500)",
              fontWeight: "medium",
            }}
          >
            マスタ管理
          </Typography>
          <Typography
            sx={{
              fontSize: "28px",
              textAlign: "right",
              color: "var(--gray-500)",
              fontWeight: "medium",
            }}
          >
            タイヤ一覧
          </Typography>
        </Box>
        <TireListSearch
          sxBox={{ flex: 1, justifyContent: "center", mt: "30px" }}
          params={params}
          setParams={setParams}
          onSearch={handleSearch}
        />
      </Box>

      <TableTireList
        tireList={tires}
        total={total}
        onPressItem={(item: Tire) => {
          setSelectedTire({ ...item });
          setIsShowModal(true);
        }}
      />
      {renderNodeLoader()}

      {selectedTire && (
        <TireFormModal
          type="update"
          visible={isShowModal}
          onClose={onHandleCloseModal}
          onHandleSubmit={onHandleUpdate}
          isLoading={loading}
          tireDetail={selectedTire}
        />
      )}
      </Box>
    </>
  );
}

export default TireList;
